import React, {
  useReducer,
  createContext,
  Dispatch,
  useEffect,
  useContext,
} from "react";
import {
  DataResponse,
  IComponent,
  ILayoutViews,
  LayoutView,
  LoadingState,
  State,
  StateActions,
} from "../types";
import { componentReducer } from "./reducer/componentReducer";
import { layoutViewReducer } from "./reducer/layoutViewReducer";
import * as ApiService from "../services/ApiService";
import { ApplicationContext, ProviderContext, ProviderContextProvider } from "../ApplicationState";
import { SET_LAYOUT } from "./ActionType";
import BreachThreshold from "../components/BreachThreshold/BreachThreshold";
import CycleDaysActivity from "../components/CycleDaysActivity/CycleDaysActivity";
import UsersComponent from "../components/UsersComponent";
import GroupReadingsComponent from "../components/GroupReadingsComponent";
import RewardsProgram from "../components/RewardsProgram/RewardsProgram";
import ScheduleMessages from "../components/ScheduleMessages/ScheduleMessages";

export const APP_STATE_NAME = "LAYOUTVIEW";


export const initialState: State = {
  views: [
    {
      id: "1",
      name: "Dashboard",
      componentLayout: [
        {
          w: 8,
          h: 3.5,
          x: 0,
          y: 0,
          i: "Breaches",
          component: {
            id: 1,
            name: "Breaches",
            displayName: "Threshold Breaches",
          },
        }, {
          w: 2,
          h: 6,
          x: 8,
          y: 0,
          i: "PendingApproval",
          component: {
            id: 9,
            name: "PendingApproval",
            displayName: "Monitor Request",
          },
        },
        {
          w: 8,
          h: 6,
          x: 0,
          y: 0,
          i: "Charts",
          component: {
            id: 3,
            name: "Charts",
            displayName: "Charts",
          },
        },
        {
          w: 8,
          h: 3.5,
          x: 0,
          y: 4,
          i: "BillingCycle",
          component: {
            id: 5,
            name: "BillingCycle",
            displayName: "Patient Activity Cycle",
          },
        },
        {
          w: 8,
          h: 4,
          x: 0,
          y: 8,
          i: "PatientList",
          component: {
            id: 2,
            name: "PatientList",
            displayName: "Patient List",
          },
        },
        {
          w: 8,
          h: 4,
          x: 0,
          y: 12,
          i: "LatestTenReadings",
          component: {
            id: 4,
            name: "LatestTenReadings",
            displayName: "Latest 10 Readings",
          },
        },
        {
          w: 8,
          h: 6,
          x: 0,
          y: 16,
          i: "RewardProgram",
          component: {
            id: 6,
            name: "RewardProgram",
            displayName: "Rewards Program",
          },
        },

        {
          w: 8,
          h: 3.5,
          x: 0,
          y: 22,
          i: "ScheduleMessages",
          component: {
            id: 7,
            name: "ScheduleMessages",
            displayName: "Schedule Messages",
          },
        },

        {
          w: 8,
          h: 3.5,
          x: 0,
          y: 30,
          i: "SurveyResults",
          component: {
            id: 8,
            name: "SurveyResults",
            displayName: "Survey Results",
          },
        }

      ],
    },
  ],

  components: [
    {
      id: 1,
      name: "Breaches",
      displayName: "Threshold Breaches",
    },
    {
      id: 2,
      name: "PatientList",
      displayName: "Patient List",
    },
    {
      id: 3,
      name: "Charts",
      displayName: "Charts",
    },
    {
      id: 4,
      name: "LatestTenReadings",
      displayName: "Latest 10 Readings",
    },
    {
      id: 5,
      name: "BillingCycle",
      displayName: "Patient Activity Cycle",
    },
    {
      id: 6,
      name: "RewardProgram",
      displayName: "Rewards Program",
    },
    {
      id: 7,
      name: "ScheduleMessages",
      displayName: "Schedule Messages",
    },
    {
      id: 8,
      name: "SurveyResults",
      displayName: "Survey Results",
    },
    {
      id: 9,
      name: "PendingApproval",
      displayName: "Monitor Request"
    },
  ],
  loading: {
    state: LoadingState.IDLE
  }
};
